import { tokenPlaceholder } from '@montugroup/circuit-shared/constants/escript';
import { TextField } from '@montugroup/design-system';
import type { TokenInputFieldProps } from './types';

export function TokenInputField({ field, fieldState }: TokenInputFieldProps) {
  const { onChange, value, ref } = field;
  const { error } = fieldState;

  return (
    <TextField
      type="text"
      variant="outlined"
      value={value}
      inputRef={ref}
      onChange={(event) => {
        const removeWhitespaceValue = event.target.value.replace(/\s/g, '');
        onChange(removeWhitespaceValue);
      }}
      label={tokenPlaceholder}
      error={Boolean(error)}
      helperText={error ? <span data-dd-privacy="allow">{error.message}</span> : ''}
      fullWidth
    />
  );
}
